export const stats = [
  { value: '6', label: 'KOMPLETNE TOMY' },
  { value: '360+', label: 'STRON' },
  { value: '120+', label: 'GOTOWYCH SESJI TRENINGOWYCH' },
  { value: '100%', label: 'GOTOWE DO UŻYCIA' },
]
